export default {
  title: 'Configuration',
  edit: {
    title: 'Modifier la configuration'
  },
  parameters: {
    PASSWORD_EXPIRATION_DELAY: 'Délai avant expiration du mot de passe'
  },
  success: {
    update: 'Configuration mise à jour',
    delete: 'Configuration réinitialisée'
  },
  errors: {
    update: 'Impossible de mettre à jour la configuration',
    loading: 'Impossible de charger la configuration',
    delete: 'Impossible de réinitialiser la configuration'
  },
  disabled: 'Désactivé'
}
